import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Welcome back, ${user.name}`);
      const target = user.role === "writer" || user.role === "admin" ? "/dashboard/writer" : "/dashboard/buyer";
      navigate(location.state?.from || target);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const cls = "bg-black/40 border-white/10 focus:border-[#FF6B00] text-white placeholder:text-white/30 h-12";

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <div className="cw-label">Log in</div>
      <h1 className="font-display text-4xl mt-3">Welcome back.</h1>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <Input required type="email" data-testid="login-email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={cls} />
        <Input required type="password" data-testid="login-password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={cls} />
        <button type="submit" disabled={loading} className="cw-btn-primary w-full h-12" data-testid="login-submit">
          {loading ? "Logging in…" : "Log in"}
        </button>
      </form>
      <div className="my-6 flex items-center gap-3 text-white/40 text-xs">
        <div className="h-px bg-white/10 flex-1" /> OR <div className="h-px bg-white/10 flex-1" />
      </div>
      <button onClick={googleLogin} className="cw-btn-ghost w-full h-12" data-testid="login-google">Continue with Google</button>
      <p className="text-center text-sm text-white/50 mt-6">
        New here? <Link to="/signup" className="text-[#FF6B00]" data-testid="link-signup">Create an account</Link>
      </p>
    </div>
  );
}
